export default "__VITE_ASSET__DXNo9QhN__"